import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from '../icon/icon.module';

export type FeedbackMessageType = 'warning' | 'invalid';
export type FeedbackMessageSize = 'x-small' | 'small';

@Component({
  selector: 'lib-feedback-message',
  standalone: true,
  imports: [IconModule],
  templateUrl: './feedback-message.component.html',
  styleUrls: ['./feedback-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackMessageComponent {
  type = input<FeedbackMessageType>('warning');
  size = input<FeedbackMessageSize>('small');
}
